import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'onlyMtpl'
})
export class OnlyMtplPipe implements PipeTransform {

  transform(value: any, ...arr: unknown[]): unknown {

    if (value) {
      const mtplIndex = value?.paymentPlans?.findIndex(item => item?.packageId === 'MTPL');
      const packageIndex = value?.paymentPlans?.findIndex(item => item?.packageId === 'P1');
      if (mtplIndex > -1 && packageIndex > -1) {
        value.paymentPlans[mtplIndex].packageRisks.packageRiskName = value.paymentPlans[packageIndex].packageRisks.packageName;
      }
    }

    return value;
  }

}
